import { canonicalPathToPortable } from '@erikdakoda/forge-mcp-helpers/workspacePath';

/**
 * Shortens workspace paths for tool-call UI labels to portable `{repoName}/...` form.
 */
export function stripOrgRepoFromWorkspacePath(path: string): string {
  return canonicalPathToPortable(path);
}
